function e(){return t}function t(...e){}export{e as doNothing};
//# sourceMappingURL=doNothing-Dhdm9wac.js.map